import styled from '@emotion/styled';

import {mixinFlexboxRow} from '@ELib/styles/mixins';

export const StyledGotoServerInstance = styled.div`
  button {
    ${mixinFlexboxRow}
    gap: var(--gutter-little);
  }
`;
